import Presenter from "./Presenter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../../usecases/object";
import Table from "../../../../../../components/Table";
import BaseListPage from "../../../../../../base/BaseListPage";
import ScheduleForm from "../ScheduleForm";
import shcema from "./scheduleSchema.json";

export default class SchedulePage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new Presenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      scheduleArray: [],
      deletedArray: [],
      objects: [],
      count: 0,
      limit: 20,
      current: 1,
    };
  }

  getCollectionName() {
    return "schedule_template";
  }

  componentDidMount() {
    this.setState({ scheduleArray: this.props.scheduleArray });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevState.scheduleArray !== this.state.scheduleArray ||
      prevProps.scheduleName !== this.props.scheduleName
    ) {
      if (
        this.state.scheduleArray.length > 0 &&
        prevState.scheduleArray !== this.state.scheduleArray
      ) {
        this.props.scheduleTable(this.state.scheduleArray);
      }
    }
  }

  scheduleTableData(object) {
    console.warn("OBJECT: ", object);
    this.setState({ scheduleArray: object });
  }

  isAddBtnClick(isCLicked) {
    this.props.isAddBtnClick(isCLicked);
  }
  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = shcema;
    const scheduleName = this.props.scheduleName;
    const { count, current, limit } = this.state;
    return (
      <>
        <ScheduleForm
          disabled={this.props.disabled}
          // refetchData={this.refetchData.bind(this)}
          scheduleName={scheduleName}
          scheduleTableData={this.scheduleTableData.bind(this)}
          schedules={this.props.scheduleArray}
          scheduleObject={this.props.scheduleObject}
          isAddBtnClick={this.isAddBtnClick.bind(this)}
        />

        <div
          style={{
            marginTop: "20px",
            width: "100%",
          }}
        >
          <h2>Schedule</h2>
        </div>
        <Table
          objectData={(data) => this.props.handleDeleteData(data)}
          // refetch={this.refetchData.bind(this)}
          // progress={count > objects.length}
          fields={schema.fields}
          objects={this.props.scheduleArray}
          collection={schema}
          count={count}
          limit={limit}
          current={current}
          loadPagination={this.onClickPagination.bind(this)}
          actionsList={
            this.props.disabled
              ? []
              : [
                  {
                    label: <i className="bi bi-trash" />,
                    actionType: "object",
                  },
                ]
          }
          excludeFields={Object.keys(schema.fields).reduce(
            (acc, key) => {
              const options = schema.fields[key];
              if (options.read === false) {
                acc.push(key);
              }
              switch (options._type || options.type) {
                case "Relation":
                case "Array":
                case "Object":
                case "File":
                  acc.push(key);
                  break;
                default:
              }
              return acc;
            },
            ["id", "Created At", "Updated At", "name"]
          )}
          onClickItem={this.onClickItem.bind(this)}
        />
      </>
    );
  }
}
